import { render, staticRenderFns } from "./PreAgent.vue?vue&type=template&id=520bcc4d&"
import script from "./PreAgent.vue?vue&type=script&lang=js&"
export * from "./PreAgent.vue?vue&type=script&lang=js&"
import style0 from "./PreAgent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports